import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Layout, Title } from 'common/components/layout';

const ResetPasswordLinkError = (props) => {
  const { settings } = props;
  if (!settings.data) {
    return (
      <Layout title="Magic Link Error" loading>
        <Title>Magic Link Error</Title>
      </Layout>
    );
  }
  return (
    <Layout title="Magic Link Error">
      <Title>Magic Link Error</Title>
      Your link has expired. Links only remain valid for 4hrs and can only be
      used once. Please use the <Link to="/profile/magic-link">
        magic link
      </Link>{' '}
      to send a new link.
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(ResetPasswordLinkError);
